export default __webpack_public_path__ + "media/images/icons_fc/project-6dcc5eaaa341101e78c67a0f70c5e0bc.png";